import * as apiOrganization from '@/api/organizations';
import store from '@/store';
export default {
    namespaced: true,
    state: {
        executor: null,
        isFetching: false,
    },
    mutations: {
        SET_EXECUTOR(state, payload) {
            state.executor = payload;
            state.isFetching = false;
        },
        SET_FETCHING(state){
            state.isFetching = true;
        }
    },
    actions: {
        async LOAD_EXECUTOR({commit}){
            if( ! store.getters['workspace/ORGANIZATION_HAS'] ){
                return;
            }
            commit('SET_FETCHING');
            try{
                let {data} = await apiOrganization.organizationExecutorIndex(
                    store.getters['workspace/ID_WORK_SPACE'], 
                    store.getters['workspace/ORGANIZATION_ID']
                );
                commit('SET_EXECUTOR', data);
            }catch(e){
                console.log(e);
                commit('SET_EXECUTOR', null);
                store.dispatch('notifications/SHOW_ERROR', e);
            }
        },

        async STORE_OR_UPDATE_EXECUTOR({dispatch, getters}, payload){
            let action = '';
            if(getters.HAS_EXECUTOR){
                action = 'UPDATE_EXECUTOR';
            }else{
                action = 'STORE_EXECUTOR';
            }
            return await dispatch(action, payload);
        },

        async UPDATE_EXECUTOR({commit, getters}, payload){
            if( ! store.getters['workspace/ORGANIZATION_HAS'] || ! getters.EXECUTOR_ID){
                return;
            }
            commit('SET_FETCHING');
            try{
                let {data} = await apiOrganization.organizationExecutorUpdate(
                    store.getters['workspace/ID_WORK_SPACE'], 
                    store.getters['workspace/ORGANIZATION_ID'],
                    getters.EXECUTOR_ID,
                    payload
                );
                commit('SET_EXECUTOR', data);
                return {result: 'ok'};
            }catch(e){
                console.log(e);
                store.dispatch('notifications/SHOW_ERROR', e);
                commit('SET_EXECUTOR', getters.EXECUTOR);
                return {result: 'error', error: e};
            }
        },

        async STORE_EXECUTOR({commit}, payload){
            if( ! store.getters['workspace/ORGANIZATION_HAS'] ){
                return;
            }
            try{
                let {data} = await apiOrganization.organizationExecutorStore(
                    store.getters['workspace/ID_WORK_SPACE'], 
                    store.getters['workspace/ORGANIZATION_ID'],
                    payload
                );
                commit('SET_EXECUTOR', data);
                return {result: 'ok'};
            }catch(e){
                console.log(e);
                store.dispatch('notifications/SHOW_ERROR', e);
                commit('SET_EXECUTOR', null);
                return {result: 'error', error: e};
            }
        },
    },
    getters: {
        EXECUTOR(state){
            return state.executor;
        },
        EXECUTOR_GUID(state, getters){
            return getters.HAS_EXECUTOR ? state.executor.executor_guid : null;
        },
        EXECUTOR_ID(state, getters){
            return getters.HAS_EXECUTOR ? state.executor.id : null;
        },
        HAS_EXECUTOR(state){
            return state.executor !== null && state.executor !== "";
        },
        IS_FETCHING(state){
            return state.isFetching;
        },
        FULL_NAME: (state, getters) => getters.HAS_EXECUTOR ? state.executor.full_name : null,
    },
  }